"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotMoving = exports.sync_tryPathTo = exports.faceXY = exports.faceIIJ = exports.nx_pathTo = exports.syncTryPathOffset = exports.setNewPathSingle = exports.setNewPath = exports.clearAfterMoveAction = exports.nr_tryPathTo = exports.tryPathTo_testOnly = exports.update = exports.updateTick = exports.isFinalMove = exports.instantMoveToIJ = exports.clearPath = exports.instantUpdateLerpToCurrentPosition = exports.lerpToIJ = exports.moveTime = exports.footstepTime = void 0;
var diveAstar_1 = require("@dive/astar/diveAstar");
var diveAstar_sidecar_1 = require("@dive/astar/diveAstar-sidecar");
var diveDebug_sidecar_1 = require("@dive/debug/diveDebug-sidecar");
var diveObjects_sidecar_1 = require("@dive/entities/diveObjects-sidecar");
var diveTilemap_sidecar_1 = require("@dive/tilemap/diveTilemap-sidecar");
var perf2_sidecar_1 = require("@engine/perf2-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var diveCrew_1 = require("@voyage/crew/diveCrew");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var diveMessage_mouseInput_1 = require("@voyage/multi/diveMessage_mouseInput");
var diveMessage_mouseInput_sidecar_1 = require("@voyage/multi/diveMessage_mouseInput-sidecar");
var voyageSounds_sidecar_1 = require("@voyage/sounds/voyageSounds-sidecar");
var diveCrew_hero_1 = require("./diveCrew_hero");
exports.footstepTime = 0.25;
exports.moveTime = 0.25;
// export const coffeeMultiplier = 0.5
// const elevatorMoveTime = 0.5
function lerpToIJ(obj, iij, moveTime) {
    obj.i = iij.i;
    obj.j = iij.j;
    var t = diveTilemap_sidecar_1.diveTilemap.getSafe(iij.i, iij.j);
    diveCrew_sidecar_1.diveCrew.setTile(obj, t);
    // Slash debugging
    // let effect = diveSlashEffect.create(EDiveSlashEffect.Slash)
    // diveSlashEffect.moveToIJ(effect, iij)
    if (t) {
        obj.lerp_start_x = obj.x;
        obj.lerp_start_y = obj.y;
        obj.lerp_target_x = t.x;
        obj.lerp_target_y = t.y;
        obj.lerp_isLerping = true;
        obj.lerp_time = 0;
        obj.lerp_timeMax = moveTime;
    }
}
exports.lerpToIJ = lerpToIJ;
function instantUpdateLerpToCurrentPosition(obj) {
    obj.lerp_target_x = obj.x;
    obj.lerp_target_y = obj.y;
    obj.lerp_start_x = obj.x;
    obj.lerp_start_y = obj.y;
}
exports.instantUpdateLerpToCurrentPosition = instantUpdateLerpToCurrentPosition;
function clearPath(obj) {
    obj.pathResult = null;
    obj.pathIdx = 0;
    obj.moveTimer = 0;
}
exports.clearPath = clearPath;
function instantMoveToIJ(obj, iij) {
    diveCrew_sidecar_1.diveCrew.moveToIIJ(obj, iij);
    clearPath(obj);
    instantUpdateLerpToCurrentPosition(obj);
}
exports.instantMoveToIJ = instantMoveToIJ;
function isFinalMove(obj) {
    if (!obj.pathResult) {
        return true;
    }
    if (obj.pathIdx >= obj.pathResult.path.length) {
        return true;
    }
    return false;
}
exports.isFinalMove = isFinalMove;
function updateTick(obj) {
    if (diveCrew_sidecar_1.diveCrew.isUnableToAct(obj)) {
        return;
    }
    if (diveDebug_sidecar_1.diveDebug.debug_noMovement) {
        return;
    }
    obj.moveTimer += 1;
    if (obj.pathResult) {
        var ps = obj.pathResult.path;
        if (ps.length > 0) {
            // obj.footstepTimer += ds
            // if (obj.footstepTimer > footstepTime) {
            //   obj.footstepTimer -= footstepTime
            //   // voyageSounds.playFootstep()
            // }
            // let moveMultiplier = 1
            // if (diveCrew.isHolding(obj, EVoyageCarryableType.Coffee)) {
            //   moveMultiplier *= coffeeMultiplier
            // }
            // Hack for now
            var curMoveTime = 5; //moveTime * moveMultiplier
            if (obj.enemyState) {
                curMoveTime = obj.enemyState.data.moveTime;
            }
            if (obj.moveTimer >= curMoveTime) {
                var nextStep = ps[obj.pathIdx];
                if (nextStep) {
                    var tCur = diveTilemap_sidecar_1.diveTilemap.getSafe(obj.i, obj.j);
                    assert_sidecar_1.assert.notNil(tCur, 'tnext is null?');
                    obj.moveTimer = 0;
                    obj.pathIdx++;
                    lerpToIJ(obj, nextStep, curMoveTime / 10);
                    // voyageSounds.playFootstep()
                }
                else {
                    // No more next steps
                    obj.pathResult = null;
                    if (obj.heroState) {
                        onCrew_finishedMovement(obj);
                    }
                }
            }
        }
    }
}
exports.updateTick = updateTick;
function onCrew_finishedMovement(obj) {
    if (!obj.heroState) {
        return;
    }
    if (obj.heroState.afterMove_action === diveCrew_hero_1.EDiveAfterMoveAction.Open) {
        var dungeonObj = diveObjects_sidecar_1.diveObjects.getByIdSafe(obj.heroState.afterMove_target_id);
        // let dungeonObj = diveObjects.getAtIJ(
        //   obj.heroState.afterMove_target_i,
        //   obj.heroState.afterMove_target_j,
        // )
        if (dungeonObj &&
            dungeonObj.i === obj.heroState.afterMove_target_i &&
            dungeonObj.j === obj.heroState.afterMove_target_j) {
            diveObjects_sidecar_1.diveObjects.do_open(dungeonObj);
        }
        else {
            console.warn('no object to open');
        }
    }
    if (obj.heroState.afterMove_action === diveCrew_hero_1.EDiveAfterMoveAction.Smash) {
        var dungeonObj = diveObjects_sidecar_1.diveObjects.getByIdSafe(obj.heroState.afterMove_target_id);
        // let dungeonObj = diveObjects.getAtIJ(
        //   obj.heroState.afterMove_target_i,
        //   obj.heroState.afterMove_target_j,
        // )
        if (dungeonObj &&
            dungeonObj.i === obj.heroState.afterMove_target_i &&
            dungeonObj.j === obj.heroState.afterMove_target_j) {
            diveObjects_sidecar_1.diveObjects.do_smash(dungeonObj);
        }
        else {
            console.warn('no object to smash');
        }
    }
    if (obj.heroState.afterMove_action === diveCrew_hero_1.EDiveAfterMoveAction.PickUp) {
        // let dungeonObj = diveObjects.getAtIJ(
        //   obj.heroState.afterMove_target_i,
        //   obj.heroState.afterMove_target_j,
        // )
        // console.log('after move pickup')
        var dungeonObj = diveObjects_sidecar_1.diveObjects.getByIdSafe(obj.heroState.afterMove_target_id);
        //   obj.heroState.afterMove_target_i,
        //   obj.heroState.afterMove_target_j,
        // )
        if (dungeonObj &&
            dungeonObj.i === obj.heroState.afterMove_target_i &&
            dungeonObj.j === obj.heroState.afterMove_target_j) {
            diveObjects_sidecar_1.diveObjects.do_pickup(obj, dungeonObj);
        }
        else {
            console.warn('no object to pick up');
        }
    }
    obj.heroState.afterMove_action = diveCrew_hero_1.EDiveAfterMoveAction.None;
}
function update(obj) {
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    if (obj.lerp_isLerping) {
        obj.lerp_time += ds;
        var t = obj.lerp_time / (obj.lerp_timeMax || 1);
        t = mathUtils_sidecar_1.mathUtils.clamp(t, 0, 1);
        diveCrew_sidecar_1.diveCrew.moveToXY(obj, mathUtils_sidecar_1.mathUtils.lerp(obj.lerp_start_x, obj.lerp_target_x, t), mathUtils_sidecar_1.mathUtils.lerp(obj.lerp_start_y, obj.lerp_target_y, t));
    }
}
exports.update = update;
function tryPathTo_testOnly(obj, i, j, mode) {
    return nr_tryPathTo(obj, i, j, mode, true);
}
exports.tryPathTo_testOnly = tryPathTo_testOnly;
function nr_tryPathTo(obj, i, j, mode, testOnly) {
    if (testOnly === void 0) { testOnly = false; }
    return perf2_sidecar_1.perf2.measure('nr_tryPathTo', function () {
        if (obj.isPassedOut) {
            return false;
        }
        var allowNextTo = mode === diveAstar_1.EDivePathToMode.OnOrNextTo || mode === diveAstar_1.EDivePathToMode.NextTo;
        var tStart = diveTilemap_sidecar_1.diveTilemap.getSafe(obj.i, obj.j);
        var tEnd = diveTilemap_sidecar_1.diveTilemap.getSafe(i, j);
        if (tStart === tEnd) {
            return false; // Already there
        }
        // if (allowNextTo) {
        //   // TODO: are we already here?
        // }
        var pathResult = null;
        var cantMoveHere = false;
        if (tEnd && tStart) {
            // Early short-circuit
            if (!allowNextTo && !tEnd.tile1.canWalk) {
                cantMoveHere = true;
            }
            if (!cantMoveHere) {
                pathResult = diveAstar_sidecar_1.diveAstar.findPath(tStart, tEnd, mode);
                if (!pathResult.isSuccess) {
                    cantMoveHere = true;
                }
                if (pathResult.path.length > 0) {
                    var first = pathResult.path[0];
                    if (first.i === obj.i && first.j === obj.j) {
                        pathResult.path.shift(); // First one is always current position
                    }
                }
                // if (pathResult.path.length <= 0) {
                //   pathResult = null
                // }
                // TODO: fix this
                // } else {
                //   obj.pathIdx = 0
                //   obj.moveTimer = 0 // moveTime / 2
                // }
            }
            else {
                cantMoveHere = true;
            }
        }
        if (cantMoveHere && obj.type === diveCrew_1.EVoyageCrewType.Hero) {
            // Only play sounds if crew
            voyageSounds_sidecar_1.voyageSounds.playCantMoveThere();
        }
        var foundPath = pathResult && pathResult.isSuccess; //pathResult != null && pathResult.path.length > 0
        if (foundPath && !testOnly) {
            var lastTile = pathResult === null || pathResult === void 0 ? void 0 : pathResult.path.pop();
            if (lastTile) {
                // Send input to the server
                diveMessage_mouseInput_sidecar_1.diveMessage_mouseInput.sendMessageToAll({
                    frame: 0,
                    hint: diveMessage_mouseInput_1.EDiveInputHint.Move,
                    targetId: obj.id,
                    fromMultiId: voyageWebsockets_sidecar_1.voyageWebsockets.getMultiId(),
                    tx: lastTile.i,
                    ty: lastTile.j,
                    centerOn: false,
                });
            }
        }
        return foundPath;
    });
}
exports.nr_tryPathTo = nr_tryPathTo;
function clearAfterMoveAction(obj) {
    if (obj.heroState) {
        // Clear our after move state
        obj.heroState.afterMove_action = diveCrew_hero_1.EDiveAfterMoveAction.None;
    }
}
exports.clearAfterMoveAction = clearAfterMoveAction;
function setNewPath(obj, path) {
    clearAfterMoveAction(obj);
    obj.pathResult = path;
    obj.pathIdx = 0;
    // obj.moveTimer = mathUtils.min(moveTime, Math.floor(moveTime * (2 / 3)))
}
exports.setNewPath = setNewPath;
function setNewPathSingle(obj, tile) {
    if (tile) {
        setNewPath(obj, {
            isSuccess: true,
            path: [tile],
            isTimeout: false,
        });
    }
}
exports.setNewPathSingle = setNewPathSingle;
function syncTryPathOffset(obj, oi, oj) {
    var gs = diveTilemap_sidecar_1.diveTilemap.getSafe(obj.i + oi, obj.j + oj);
    if (gs && diveAstar_sidecar_1.diveAstar.canWalkTile(gs)) {
        setNewPath(obj, {
            isSuccess: true,
            path: [gs],
            isTimeout: false,
        });
    }
}
exports.syncTryPathOffset = syncTryPathOffset;
function nx_pathTo(msg) {
    assert_sidecar_1.assert.eq(msg.hint, diveMessage_mouseInput_1.EDiveInputHint.Move);
    var obj = diveCrew_sidecar_1.diveCrew.findById(msg.targetId);
    assert_sidecar_1.assert.notNil(obj);
    var path = sync_tryPathTo(obj, msg.tx, msg.ty, diveAstar_1.EDivePathToMode.On, true);
    setNewPath(obj, path);
    if (!path) {
        console.warn('no path found', 'nx_pathTo');
    }
}
exports.nx_pathTo = nx_pathTo;
function faceIIJ(obj, target) {
    var e = 0.1;
    if (target.i - obj.i < -e) {
        obj.isFlipped = true;
    }
    if (target.i - obj.i > e) {
        obj.isFlipped = false;
    }
}
exports.faceIIJ = faceIIJ;
function faceXY(obj, targetX, targetY) {
    var e = 0.1;
    if (targetX - obj.x < -e) {
        obj.isFlipped = true;
    }
    if (targetX - obj.x > e) {
        obj.isFlipped = false;
    }
}
exports.faceXY = faceXY;
function sync_tryPathTo(obj, i, j, mode, allowPathLengthZero) {
    if (obj.isPassedOut || obj.isDead || obj.isDying) {
        return null;
    }
    var tStart = diveTilemap_sidecar_1.diveTilemap.getSafe(obj.i, obj.j);
    var tEnd = diveTilemap_sidecar_1.diveTilemap.getSafe(i, j);
    if (!allowPathLengthZero) {
        if (tStart === tEnd) {
            return null; // Already there
        }
    }
    var pathResult = null;
    var cantMoveHere = false;
    if (tEnd && tStart) {
        if (tEnd.tile1.canWalk) {
            pathResult = perf2_sidecar_1.perf2.measure('sync_tryPathTo-findPath', function () {
                assert_sidecar_1.assert.notNil(tStart);
                assert_sidecar_1.assert.notNil(tEnd);
                return diveAstar_sidecar_1.diveAstar.findPath(tStart, tEnd, mode);
            });
            if (!pathResult.isSuccess) {
                cantMoveHere = true;
            }
            if (pathResult.path.length > 0) {
                var first = pathResult.path[0];
                if (first.i === obj.i && first.j === obj.j) {
                    pathResult.path.shift(); // First one is always current position
                }
            }
            if (pathResult.path.length <= 0) {
                if (!allowPathLengthZero) {
                    pathResult = null;
                }
            }
        }
        else {
            cantMoveHere = true;
        }
    }
    // TOOD: sounds??
    // if (cantMoveHere && obj.type === EVoyageCrewType.Crew) {
    //   // Only play sounds if crew
    //   voyageSounds.playCantMoveThere()
    // }
    var foundPath = pathResult && pathResult.isSuccess;
    return foundPath ? pathResult : null;
}
exports.sync_tryPathTo = sync_tryPathTo;
function isNotMoving(obj) {
    return !obj.pathResult || obj.pathIdx >= obj.pathResult.path.length;
}
exports.isNotMoving = isNotMoving;
